module.exports = __webpack_public_path__ + "static/img/qr-code.8de2c34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/qr-code.png
// module id = E4PC
// module chunks = 0